import React,{useState} from 'react';
import {Layout} from 'antd';
import { Header } from '../../components/header';
import {Sample} from '../sample/Sample';
import {UserPage} from '../user/User';
import {Setting} from '../setting/Setting';
import {Count} from "../../components/count/Count";
import {Inout} from "../inout/Inout";
export const Home:React.FC = () => {
  const [type,setType] = useState(0);
  return (
    <>
    <Header setNavNo={setType}/>
    <Layout.Content>
      {type === 0 && <Sample/>}
      {type === 1 && <UserPage/>}
      {type === 2 && <Setting/>}
      {type === 3 && <Count/>}
      {type === 4 && <Inout/>}
    </Layout.Content>
    </>
  );

}